import Vue from 'vue'
import ZendeskPlugin from './plugin'
// инициализация zendesk
Vue.use(ZendeskPlugin, {
  key: process.env.VUE_APP_ZENDESK_KEY,
  disabled: true,
  hideOnLoad: false,
  logger: false,
  settings: {
    webWidget: {
      color: {
        theme: '#ff2f00'
      }
    }
  }
})
